/**
 * OmniLeagues — OFFICIAL role display names (single source).
 *
 * These are the labels shown to users for each OL `role_type`. The canonical set
 * is the /dev Quick Demo Access labels (pages/DevAuthPage.js). Change a label HERE
 * ONLY — never duplicate this map elsewhere. Role `role_type` values, permissions
 * and data are unaffected.
 */
export const ROLE_NAMES = {
  semprion_admin: 'Semprion HQ',
  company_support: 'Admin',
  league_admin: 'League',
  ad: 'AD',
  aad: 'Assistant AD',
  scheduler: 'Scheduler',
  tech_specialist: 'Technology Specialist',
  treasurer: 'Treasurer',
  accountant: 'Accountant',
  coach: 'Coach',
  family: 'Family',
  admin: 'Admin',
  developer: 'Developer',
};

export const roleName = (rt) => ROLE_NAMES[rt] || rt || '—';
